import React from 'react';
import { formatDuration } from '../../utils/date';

interface IDurationCellProps {
  seconds?: number | null;
}

const DurationCell: React.FC<IDurationCellProps> = ({ seconds }) => (
  <span>{formatDuration(seconds)}</span>
);

export default DurationCell;
